// src/views/CustomerAssets/CustomerAssets.jsx
import React, {useState, useEffect} from "react";
import axios from "axios";
// import handleErrors from "src/helpers/handleErrors";

// Material Dashboard React / Material-UI v4
import Grid from "@material-ui/core/Grid";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import CircularProgress from "@material-ui/core/CircularProgress";
import {makeStyles} from "@material-ui/core/styles";
import DetailsModal from "./Details/DetailsModal";
import CustomMap from "components/CustomMap/CustomMap";
import CabinetDetails from "./Details/CabinetDetails";

// NOTE: If you already have these custom components in your project,
// replace the placeholder implementations below with the real imports:
// import DetailsModal from './Details/DetailsModal';
// import CustomGrid from 'src/components/GridView/CustomGrid';
// import CustomFilterButton from 'src/components/CustomFilterButton/CustomFilterButton';
// import FilterModal from './FilterModal';
// import CustomMap from 'src/components/CustomMap/CustomMap';
// import CustomTabs from 'src/components/CustomTabs/CustomTabs';

/* ---------------------- Placeholder components ----------------------
   These small placeholders let the file run as-is. Replace them with
   your actual implementations for full UI/UX.
--------------------------------------------------------------------*/
const useStyles = makeStyles((theme) => ({
  rootCard: {
    backgroundColor: "transparent",
    textAlign: "center",
  },
  noData: {
    textAlign: "center",
    width: "100%",
    marginTop: "5rem",
  },
  sectionTitle: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(1),
  },
  spinnerWrap: {
    marginTop: theme.spacing(2),
  },
}));

const CustomFilterButton = ({onClick}) => (
  <div style={{textAlign: "right", marginBottom: 8}}>
    <button onClick={onClick} style={{padding: "6px 10px", cursor: "pointer"}}>
      Filter
    </button>
  </div>
);

const CustomTabs = ({tabs, onTabChange, tabValue}) => {
  // Minimal tabs placeholder — replace with your real CustomTabs
  return (
    <div style={{display: "flex", justifyContent: "center", marginBottom: 8}}>
      {tabs.map((t, i) => (
        <button
          key={i}
          onClick={(e) => onTabChange(e, i)}
          style={{
            margin: "0 6px",
            padding: "6px 12px",
            cursor: "pointer",
            background: tabValue === i ? "#1976d2" : "#fff",
            color: tabValue === i ? "#fff" : "#000",
            border: "1px solid #ddd",
            borderRadius: 4,
          }}
        >
          {t}
        </button>
      ))}
    </div>
  );
};

const CustomGrid = ({data, index, onClick}) => {
  // Very small card-like placeholder: shows name and clickable
  return (
    <div
      onClick={onClick}
      style={{
        border: "1px solid #e0e0e0",
        borderRadius: 6,
        padding: 12,
        cursor: "pointer",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
      }}
    >
      {data?.type.photo ? (
        <img
          className="image-default"
          src={`${process.env.REACT_APP_BASE_URL}/uploads/fridges-types/${data?.type?.photo}`}
          alt="Card Image Default"
          loading="lazy"
        />
      ) : (
        <div className="image-default"></div>
      )}

      <div style={{fontWeight: 600}}>{data?.type?.name}</div>
      {/* <div style={{fontSize: 12, color: "#666", marginTop: 8}}>{data?.type.refrigerant_type}</div> */}
      <div style={{fontSize: 12, color: "#666", marginTop: 8}}>{data?.type.code}</div>
    </div>
  );
};

// const CustomMap = ({inTabs, markers, markersTitle, onMarkerClick}) => {
//   // Placeholder map: renders simple list of markers clickable
//   return (
//     <div style={{padding: 12, border: "1px dashed #ccc", borderRadius: 6}}>
//       <h4 style={{marginTop: 0}}>Map placeholder</h4>
//       {(!markers || markers.length === 0) && <div>No markers</div>}
//       {markers &&
//         markers.map((m, i) => (
//           <div key={i} onClick={() => onMarkerClick(m.id, i, m)} style={{cursor: "pointer", padding: 6}}>
//             {m[markersTitle] || `Marker ${i + 1}`}
//           </div>
//         ))}
//     </div>
//   );
// };

// const DetailsModal = ({
//   index,
//   visible,
//   handleNext,
//   handlePrevious,
//   handleClose,
//   data,
//   totalItems,
//   sliderIndex,
// }) => {
//   if (!visible) return null;
//   return (
//     <div
//       style={{
//         position: "fixed",
//         zIndex: 9999,
//         left: 0,
//         right: 0,
//         top: 0,
//         bottom: 0,
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         background: "rgba(0,0,0,0.5)",
//       }}
//     >
//       <div style={{background: "#fff", padding: 20, width: 720, borderRadius: 8}}>
//         <h3 style={{marginTop: 0}}>{data?.asset_name || "Details"}</h3>
//         <div style={{minHeight: 80}}>
//           <pre style={{whiteSpace: "pre-wrap", fontSize: 12}}>{JSON.stringify(data, null, 2)}</pre>
//         </div>
//         <div style={{display: "flex", justifyContent: "space-between", marginTop: 12}}>
//           <button onClick={() => handlePrevious()}>Previous</button>
//           <div>
//             <button onClick={() => handleClose(false)} style={{marginRight: 8}}>
//               Close
//             </button>
//             <button onClick={() => handleNext()}>Next</button>
//           </div>
//         </div>
//         <div style={{marginTop: 8, fontSize: 12}}>
//           {sliderIndex}/{totalItems}
//         </div>
//       </div>
//     </div>
//   );
// };

const FilterModal = ({
  filterForm,
  handleChangeInputFilter,
  customOnChangeFilter,
  handleclear,
  visible,
  handleClose,
  handleSave,
}) => {
  if (!visible) return null;
  return (
    <div
      style={{
        position: "fixed",
        zIndex: 9998,
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "rgba(0,0,0,0.4)",
      }}
    >
      <div style={{background: "#fff", padding: 20, width: 640, borderRadius: 8}}>
        <h3 style={{marginTop: 0}}>Filter</h3>
        <div style={{display: "flex", gap: 12}}>
          <div style={{flex: 1}}>
            <label>Customer IDs (comma separated)</label>
            <input
              id="customer_ids"
              value={
                filterForm.customer_ids.join ? filterForm.customer_ids.join(",") : filterForm.customer_ids
              }
              onChange={(e) =>
                handleChangeInputFilter({
                  target: {
                    id: "customer_ids",
                    value: e.target.value.split(",").map((s) => s.trim()),
                    type: "text",
                  },
                })
              }
              style={{width: "100%", padding: 8, marginTop: 6}}
            />
          </div>
          <div style={{flex: 1}}>
            <label>Location IDs (comma separated)</label>
            <input
              id="location_ids"
              value={
                filterForm.location_ids.join ? filterForm.location_ids.join(",") : filterForm.location_ids
              }
              onChange={(e) =>
                handleChangeInputFilter({
                  target: {
                    id: "location_ids",
                    value: e.target.value.split(",").map((s) => s.trim()),
                    type: "text",
                  },
                })
              }
              style={{width: "100%", padding: 8, marginTop: 6}}
            />
          </div>
        </div>

        <div style={{marginTop: 16, display: "flex", justifyContent: "flex-end", gap: 8}}>
          <button
            onClick={() => {
              handleclear();
            }}
          >
            Clear
          </button>
          <button onClick={() => handleClose(false)}>Cancel</button>
          <button
            onClick={() => {
              handleSave();
              handleClose(false);
            }}
          >
            Save
          </button>
        </div>
      </div>
    </div>
  );
};
/* -------------------- end placeholders -------------------- */

const CabinetsListMap = () => {
  const classes = useStyles();
  const [selectedCabinet, setSelectedCabinet] = useState(null);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [data, setData] = useState([]);
  const [dataByLocationCategory, setDataByLocationCategory] = useState([]);
  const [dataCustomerLocations, setDataCustomerLocations] = useState([]);
  const [selectedItem, setSelectedItem] = useState({});
  const [totalItems, setTotalItems] = useState(0);
  const [currentIndex, setCurrentIndex] = useState(null);
  const [sliderIndex, setSliderIndex] = useState(null);
  const [visible, setVisible] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedLocationId, setSelectedLocationId] = useState(null);
  const [selectedCategoryId, setSelectedCategoryId] = useState(null);
  const [filterVisible, setFilterVisible] = useState(false);
  const [filterForm, setFilterForm] = useState({
    customer_ids: [],
    location_ids: [],
  });

  const handleclearFilter = () => {
    setFilterForm({
      customer_ids: [],
      location_ids: [],
    });
  };

  const getData = () => {
    setIsLoading(true);
    // axios.get(
    //   `${process.env.REACT_APP_API_BASE_URL}/Logistics/Operations/CustomerAssets/getAssetsByLocations`,
    //   {
    //     params: {
    //       customer_ids: filterForm.customer_ids,
    //       location_ids: filterForm.location_ids,
    //     },
    //   }
    // );

    axios
      .get(`${process.env.REACT_APP_BASE_URL}/store_cabinets`)
      .then(function (response) {
        setDataCustomerLocations(response.data.storeCabinets);
        setData(response.data.groupedByFridgeType);
        // setData(response.data);
        // setDataCustomerLocations(
        //   response.data.filter((v) => v.location_type === "customer_location" || v.location_type === "store")
        // );
        // const dataWithLocationCategory = response.data.filter((v) => v.location_category_id > 0);
        // const dataByLocationCategoryTemp = [];
        // dataWithLocationCategory.forEach((element) => {
        //   if (!dataByLocationCategoryTemp[element.location_category_id]) {
        //     dataByLocationCategoryTemp[element.location_category_id] = {
        //       location_category_id: element.location_category_id,
        //       location_category_name: element.location_category_name,
        //       details: [],
        //     };
        //   }
        //   dataByLocationCategoryTemp[element.location_category_id].details.push(element);
        // });
        // setDataByLocationCategory(dataByLocationCategoryTemp);
        setIsLoading(false);
      })
      .catch(function (error) {
        // handleErrors(error);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const openDetails = (id, index, locationData, categoryData) => {
    let selected = null;
    let total = 0;
    let sliderIdx = 1;
    let currentIdx = index;

    if (locationData) {
      // Filter all cabinets in this store
      const filteredIndexes = dataCustomerLocations.reduce((indexes, val, idx) => {
        if (val.location_id == locationData.location_id) {
          indexes.push(idx);
        }
        return indexes;
      }, []);

      total = filteredIndexes.length;
      currentIdx = filteredIndexes[0];
      selected = {
        ...dataCustomerLocations[filteredIndexes[0]],
        location_name: locationData.name || null,
        location_code: locationData.code || null,
        lat: locationData.lat || null,
        lon: locationData.lon || null,
      };
      sliderIdx = 1;
      setSelectedLocationId(locationData.location_id);
    } else if (categoryData) {
      // Cabinets grouped by category
      total = categoryData.details.length;
      selected = {
        ...categoryData.details[index],
        location_name: categoryData.details[index].location_name || null,
        location_code: categoryData.details[index].location_code || null,
        lat: categoryData.details[index].lat || null,
        lon: categoryData.details[index].lon || null,
      };
      sliderIdx = index + 1;
      setSelectedCategoryId(categoryData.location_category_id);
    } else {
      // Default: single cabinet from full data

      //   total = data[index].cabinets.length;
      total = data.length;
      selected = {
        ...data[index],
        location_name: data[index].location_name || null,
        location_code: data[index].location_code || null,
        lat: data[index].lat || null,
        lon: data[index].lon || null,
      };
      sliderIdx = index + 1;
    }

    setTotalItems(total);
    setCurrentIndex(currentIdx);
    setSelectedItem(selected);
    setSliderIndex(sliderIdx);
    setVisible(true);
  };

  //   const openDetails = (id, index, locationData, categoryData) => {
  //     if (locationData) {
  //       setSelectedLocationId(locationData.location_id);
  //       const filteredIndexes = dataCustomerLocations.reduce((indexes, val, idx) => {
  //         if (val.location_id == locationData.location_id) {
  //           indexes.push(idx);
  //         }
  //         return indexes;
  //       }, []);
  //       setTotalItems(filteredIndexes.length);
  //       setCurrentIndex(filteredIndexes[0]);
  //       setSelectedItem(dataCustomerLocations[filteredIndexes[0]]);
  //       setSliderIndex(1);
  //     } else if (categoryData) {
  //       setSelectedCategoryId(categoryData.location_category_id);
  //       setTotalItems(categoryData.details.length);
  //       setCurrentIndex(index);
  //       setSelectedItem(categoryData.details[index]);
  //       setSliderIndex(index + 1);
  //     } else {
  //       setTotalItems(data.length);
  //       setCurrentIndex(index);
  //       setSelectedItem(data[index]);
  //       setSliderIndex(index + 1);
  //     }
  //     setVisible(true);
  //   };

  const handleClose = (refresh) => {
    setVisible(false);
    setSelectedLocationId(null);
    setSelectedCategoryId(null);
    setSelectedItem({});
    setTotalItems(0);
    setSliderIndex(null);
    if (refresh === true) {
      getData();
    }
  };

  const handleNext = () => {
    if (selectedLocationId) {
      const filteredIndexes = dataCustomerLocations.reduce((indexes, val, idx) => {
        if (val.location_id == selectedLocationId) {
          indexes.push(idx);
        }
        return indexes;
      }, []);
      setCurrentIndex((prevIndex) => {
        const indx = filteredIndexes.indexOf(prevIndex);
        let inx = filteredIndexes[indx + 1]
          ? filteredIndexes[indx + 1] % dataCustomerLocations.length
          : filteredIndexes[0];
        setSelectedItem(dataCustomerLocations[inx]);
        setSliderIndex((prevSliderIndx) => {
          if (prevSliderIndx + 1 > filteredIndexes.length) {
            return 1;
          }
          return prevSliderIndx + 1;
        });
        return inx;
      });
    } else if (selectedCategoryId) {
      const selectedDataByLocationCategory = dataByLocationCategory.filter(
        (v) => v.location_category_id == selectedCategoryId
      )[0];
      setCurrentIndex((prevIndex) => {
        let inx = (prevIndex + 1) % selectedDataByLocationCategory.details.length;
        setSelectedItem(selectedDataByLocationCategory.details[inx]);
        setSliderIndex(inx + 1);
        return inx;
      });
    } else {
      setCurrentIndex((prevIndex) => {
        let inx = (prevIndex + 1) % data.length;
        setSelectedItem(data[inx]);
        setSliderIndex(inx + 1);
        return inx;
      });
    }
  };

  const handlePrevious = () => {
    if (selectedLocationId) {
      const filteredIndexes = dataCustomerLocations.reduce((indexes, val, idx) => {
        if (val.location_id == selectedLocationId) {
          indexes.push(idx);
        }
        return indexes;
      }, []);
      setCurrentIndex((prevIndex) => {
        const indx = filteredIndexes.indexOf(prevIndex);
        let inx = filteredIndexes[indx - 1]
          ? (filteredIndexes[indx - 1] + dataCustomerLocations.length) % dataCustomerLocations.length
          : filteredIndexes[filteredIndexes.length - 1];
        setSelectedItem(dataCustomerLocations[inx]);
        setSliderIndex((prevSliderIndx) => {
          if (prevSliderIndx - 1 <= 0) {
            return filteredIndexes.length;
          }
          return prevSliderIndx - 1;
        });
        return inx;
      });
    } else if (selectedCategoryId) {
      const selectedDataByLocationCategory = dataByLocationCategory.filter(
        (v) => v.location_category_id == selectedCategoryId
      )[0];
      setCurrentIndex((prevIndex) => {
        let inx =
          (prevIndex - 1 + selectedDataByLocationCategory.details.length) %
          selectedDataByLocationCategory.details.length;
        setSelectedItem(selectedDataByLocationCategory.details[inx]);
        setSliderIndex(inx + 1);
        return inx;
      });
    } else {
      setCurrentIndex((prevIndex) => {
        let inx = (prevIndex - 1 + data.length) % data.length;
        setSelectedItem(data[inx]);
        setSliderIndex(inx + 1);
        return inx;
      });
    }
  };

  const handleCloseFilter = () => {
    setFilterVisible(false);
  };

  const filterListener = () => {
    setFilterVisible(true);
  };
  const handleSaveFilter = () => {
    getData();
    handleCloseFilter();
  };

  const handleChangeInputFilter = (event) => {
    const {id, value, checked, type} = event.target;
    if (type == "checkbox") {
      setFilterForm({
        ...filterForm,
        [id]: checked,
      });
    } else {
      setFilterForm({
        ...filterForm,
        [id]: value,
      });
    }
  };

  const customOnChangeFilter = (newValue, name /*, newValueDescription, newValueObj */) => {
    setFilterForm({
      ...filterForm,
      [name]: newValue,
    });
  };

  const [Tabselected, setTabselected] = useState(0);
  const onTabChange = (event, newValue) => {
    setTabselected(newValue);
  };

  return (
    <Card className={classes.rootCard}>
      {/* <CardHeader color="transparent">
        <h4 style={{margin: 0}}>Cabinets</h4>
      </CardHeader> */}

      <CardBody>
        {/* <CustomFilterButton onClick={filterListener} /> */}

        <CustomTabs
          tabs={[
            <div key={0}>{"List"}</div>,
            <div key={1}>{"Map"}</div>,
            // <div key={2}>{"Location Category"}</div>,
          ]}
          onTabChange={onTabChange}
          tabValue={Tabselected}
        />

        {isLoading && (
          <div className={classes.spinnerWrap}>
            <CircularProgress />
          </div>
        )}

        {Tabselected === 0 && (
          <Grid container spacing={2} style={{marginTop: 8}}>
            {!isLoading && data.length === 0 && <h4 className={classes.noData}>No Assets To Show</h4>}

            {data.map((e, index) => (
              <Grid item xs={6} md={3} key={index}>
                <CustomGrid data={e} index={index} onClick={() => openDetails(e.id, index)} />
              </Grid>
            ))}
          </Grid>
        )}

        {Tabselected === 1 && (
          <div style={{marginTop: 8}}>
            <CustomMap
              setSelectedCabinet={setSelectedCabinet}
              inTabs={true}
              markers={dataCustomerLocations}
              markersTitle={"location_name"}
              // onMarkerClick={openDetails}
              onMarkerClick={(id, index, cabinet) => {
                setSelectedCabinet(cabinet);
                setDialogOpen(true);
              }}
            />
          </div>
        )}

        {Tabselected === 2 && (
          <Grid container spacing={2} style={{marginTop: 8}}>
            {dataByLocationCategory.length === 0 && <h4 className={classes.noData}>No Assets To Show</h4>}

            {dataByLocationCategory.map((e, index) => (
              <Grid item xs={12} md={12} key={index}>
                <h3 className={classes.sectionTitle}>{e.location_category_name}</h3>
                <hr />
                <Grid container spacing={2}>
                  {e.details.map((elem, index2) => (
                    <Grid item xs={6} md={3} key={index2}>
                      <CustomGrid
                        data={elem}
                        index={index2}
                        onClick={() => openDetails(elem.id, index2, undefined, e)}
                      />
                    </Grid>
                  ))}
                </Grid>
              </Grid>
            ))}
          </Grid>
        )}
      </CardBody>

      <DetailsModal
        index={currentIndex}
        visible={visible}
        handleNext={handleNext}
        handlePrevious={handlePrevious}
        handleClose={handleClose}
        data={selectedItem}
        totalItems={totalItems}
        sliderIndex={sliderIndex}
      />

      <FilterModal
        filterForm={filterForm}
        handleChangeInputFilter={handleChangeInputFilter}
        customOnChangeFilter={customOnChangeFilter}
        handleclear={handleclearFilter}
        visible={filterVisible}
        handleClose={handleCloseFilter}
        handleSave={handleSaveFilter}
      />

      <CabinetDetails open={dialogOpen} onClose={() => setDialogOpen(false)} cabinet={selectedCabinet} />
    </Card>
  );
};

export default CabinetsListMap;
